import { useMutation } from '@tanstack/react-query';

import { scoutClient } from '@/modules/scout-sourcing/scoutClient';
import type {
  ScoutMarketSizeResponse,
  ScoutSearchCriteria,
} from '@/modules/scout-sourcing/types';

type Payload = {
  jobId: string;
  jobSourcingId: string;
  searchCriteria: ScoutSearchCriteria;
};

export const usePreviewMarketSizeMutation = () =>
  useMutation<ScoutMarketSizeResponse, Error, Payload>({
    mutationFn: ({ jobId, jobSourcingId, searchCriteria }) =>
      scoutClient.previewMarketSize(jobId, jobSourcingId, searchCriteria),
  });
